import { useMutation } from '@tanstack/react-query';

import type {
  CashierFormResponse,
  CashierSubmitData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCashierFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: CashierSubmitData;
    }) =>
      HttpClient.request<CashierFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
